import CryptoJS from 'crypto-js'

var SHA384_DIGEST_LENGTH = 48;
var GEN_KEY_LENGTH = 16;
var pwd_to_string = "_abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789."

function keyForDigest_passy1(digest){

    var key = Array.apply(null, new Array(GEN_KEY_LENGTH)).map(Number.prototype.valueOf,0);
    var i_in = 0;
    var i_out = 0;
    var ibuf = 0;
    for (var i2=0; i2 < SHA384_DIGEST_LENGTH / 3; i2++)
    {
        ibuf  = 256 * 256 * digest.charCodeAt(i_in++);
        ibuf +=       256 * digest.charCodeAt(i_in++);
        ibuf +=             digest.charCodeAt(i_in++);

        key[(i_out++)%GEN_KEY_LENGTH] ^=  ibuf /64 /64 /64;
        key[(i_out++)%GEN_KEY_LENGTH] ^= (ibuf /64 /64)%64;
        key[(i_out++)%GEN_KEY_LENGTH] ^= (ibuf /64)%64;
        key[(i_out++)%GEN_KEY_LENGTH] ^=  ibuf %64;
    }

    var keystr = '';
    for (var i=0;i<GEN_KEY_LENGTH;i++)
    {
        keystr += pwd_to_string[key[i]];
        key[i]=0;
    }
    return keystr;
}

function hashOfString_passy1(astring){
    var digest = CryptoJS.SHA384(astring).toString(CryptoJS.enc.Latin1);
    return digest;
}

export function passy_passy1(mkey, tag){
    var mhash = hashOfString_passy1(mkey);
    var thash = hashOfString_passy1(tag);
    var comp = '';
    for (var i = 0; i < mhash.length; i++){
        comp += thash[i] + mhash[i];
    }
    var chash = hashOfString_passy1(CryptoJS.enc.Latin1.parse(comp));
    return keyForDigest_passy1(chash);
}
